import { Link } from "react-router-dom";
import { Star, ArrowRight } from "lucide-react";
import { reviews, googleReviews } from "../mock/mock";

export default function ReviewsPreview() {
  const top = reviews.slice(0, 3);
  return (
    <section className="max-w-7xl mx-auto px-5 py-24" data-testid="home-reviews-section">
      <div className="grid lg:grid-cols-3 gap-10 items-start">
        <div>
          <span className="text-[#1B6CA8] font-semibold tracking-[0.18em] text-xs uppercase">Omdömen</span>
          <h2 className="font-display text-3xl md:text-4xl font-bold text-[#0B2545] mt-2">Elever som rekommenderar oss</h2>
          <div className="mt-6 inline-flex items-center gap-4 p-5 rounded-2xl bg-[#0B2545] text-white" data-testid="home-google-rating">
            <span className="font-display text-5xl font-extrabold text-[#ffce3a] leading-none">{googleReviews.rating}</span>
            <div>
              <div className="flex">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={18} className="text-[#ffce3a] fill-[#ffce3a]" />
                ))}
              </div>
              <div className="text-sm text-slate-300 mt-1">{googleReviews.count} omdömen på Google</div>
            </div>
          </div>
          <Link to="/omdomen" data-testid="home-reviews-link" className="group mt-6 inline-flex items-center gap-2 font-semibold text-[#1B6CA8] hover:text-[#0B2545] transition-colors">
            Läs alla omdömen <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>
        <div className="lg:col-span-2 grid sm:grid-cols-3 gap-5">
          {top.map((r, idx) => (
            <div key={idx} data-testid={`home-review-${idx}`} className="bg-white rounded-2xl p-6 border border-slate-100 hover:shadow-xl hover:-translate-y-1 transition-all flex flex-col">
              <div className="flex mb-3">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={15} className={i < r.rating ? "text-[#ffce3a] fill-[#ffce3a]" : "text-slate-200 fill-slate-200"} />
                ))}
              </div>
              <p className="text-sm text-slate-600 leading-relaxed flex-1 line-clamp-6">”{r.text}”</p>
              <div className="flex items-center gap-2.5 mt-5 pt-4 border-t border-slate-100">
                <span className="w-9 h-9 rounded-full bg-[#0B2545] text-[#ffce3a] flex items-center justify-center font-display font-bold text-sm">{r.name.charAt(0)}</span>
                <div>
                  <div className="font-semibold text-sm text-[#0B2545]">{r.name}</div>
                  <div className="text-[11px] text-slate-400">Google · {r.date}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
